export enum GatewayTypes {
  NewInternationalCreditCard = 'NewInternationalCreditCard',
  NewLocalCreditCard = 'NewLocalCreditCard',
  PayPal = 'PayPal',
  SavedCard = 'SavedCard',
  CreditCard = 'CreditCard',
  DLocal = 'DLocal',
}
